webpackJsonp(["pages.projects.issues.index"],{

/***/ "./create_label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback */



var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["f" /* humanize */])(key) + ' ' + label.message[key].join(', ');
            }).join('<br/>');
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateLabelDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./filtered_search/filtered_search_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_token_keys.js
var filtered_search_token_keys = __webpack_require__("./filtered_search/filtered_search_token_keys.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// CONCATENATED MODULE: ./filtered_search/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// EXTERNAL MODULE: ./filtered_search/filtered_search_tokenizer.js
var filtered_search_tokenizer = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./filtered_search/components/recent_searches_dropdown_content.vue




/* harmony default export */ var recent_searches_dropdown_content = ({
  name: 'RecentSearchesDropdownContent',
  props: {
    items: {
      type: Array,
      required: true
    },
    isLocalStorageAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    allowedKeys: {
      type: Array,
      required: true
    }
  },
  computed: {
    processedItems: function processedItems() {
      var _this = this;

      return this.items.map(function (item) {
        var _FilteredSearchTokeni = filtered_search_tokenizer["a" /* default */].processTokens(item, _this.allowedKeys),
            tokens = _FilteredSearchTokeni.tokens,
            searchToken = _FilteredSearchTokeni.searchToken;

        var resultantTokens = tokens.map(function (token) {
          return {
            prefix: token.key + ':',
            suffix: '' + token.symbol + token.value
          };
        });

        return {
          text: item,
          tokens: resultantTokens,
          searchToken: searchToken
        };
      });
    },
    hasItems: function hasItems() {
      return this.items.length > 0;
    }
  },
  methods: {
    onItemActivated: function onItemActivated(text) {
      event_hub.$emit('recentSearchesItemSelected', text);
    },
    onRequestClearRecentSearches: function onRequestClearRecentSearches(e) {
      // Stop the dropdown from closing
      e.stopPropagation();

      event_hub.$emit('requestClearRecentSearches');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b166e4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./filtered_search/components/recent_searches_dropdown_content.vue
var recent_searches_dropdown_content_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLocalStorageAvailable)?_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    This feature requires local storage to be enabled\n  ")]):(_vm.hasItems)?_c('ul',[_vm._l((_vm.processedItems),function(item,index){return _c('li',{key:("processed-items-" + index)},[_c('button',{staticClass:"filtered-search-history-dropdown-item",attrs:{"type":"button"},on:{"click":function($event){_vm.onItemActivated(item.text)}}},[_c('span',_vm._l((item.tokens),function(token,index){return _c('span',{key:("dropdown-token-" + index),staticClass:"filtered-search-history-dropdown-token"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(token.prefix))]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(token.suffix))])])})),_vm._v(" "),_c('span',{staticClass:"filtered-search-history-dropdown-search-token"},[_vm._v("\n          "+_vm._s(item.searchToken)+"\n        ")])])])}),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('button',{staticClass:"filtered-search-history-clear-button",attrs:{"type":"button"},on:{"click":function($event){_vm.onRequestClearRecentSearches($event)}}},[_vm._v("\n        Clear recent searches\n      ")])])],2):_c('div',{staticClass:"dropdown-info-note"},[_vm._v("\n    You don't have any recent searches\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./filtered_search/components/recent_searches_dropdown_content.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  recent_searches_dropdown_content,
  recent_searches_dropdown_content_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_recent_searches_dropdown_content = (Component.exports);

// CONCATENATED MODULE: ./filtered_search/recent_searches_root.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var recent_searches_root_RecentSearchesRoot = function () {
  function RecentSearchesRoot(recentSearchesStore, recentSearchesService, wrapperElement) {
    _classCallCheck(this, RecentSearchesRoot);

    this.store = recentSearchesStore;
    this.service = recentSearchesService;
    this.wrapperElement = wrapperElement;
  }

  _createClass(RecentSearchesRoot, [{
    key: 'init',
    value: function init() {
      this.bindEvents();
      this.render();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onRequestClearRecentSearchesWrapper = this.onRequestClearRecentSearches.bind(this);

      event_hub.$on('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      event_hub.$off('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.store.state;
      this.vm = new vue_esm["a" /* default */]({
        el: this.wrapperElement,
        components: {
          RecentSearchesDropdownContent: components_recent_searches_dropdown_content
        },
        data: function data() {
          return state;
        },

        template: '\n        <recent-searches-dropdown-content\n          :items="recentSearches"\n          :is-local-storage-available="isLocalStorageAvailable"\n          :allowed-keys="allowedKeys"\n          />\n      '
      });
    }
  }, {
    key: 'onRequestClearRecentSearches',
    value: function onRequestClearRecentSearches() {
      var resultantSearches = this.store.setRecentSearches([]);
      this.service.save(resultantSearches);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbindEvents();
      if (this.vm) {
        this.vm.$destroy();
      }
    }
  }]);

  return RecentSearchesRoot;
}();

/* harmony default export */ var recent_searches_root = (recent_searches_root_RecentSearchesRoot);
// CONCATENATED MODULE: ./filtered_search/stores/recent_searches_store.js
var recent_searches_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var recent_searches_store_RecentSearchesStore = function () {
  function RecentSearchesStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allowedKeys = arguments[1];

    recent_searches_store__classCallCheck(this, RecentSearchesStore);

    this.state = Object.assign({
      isLocalStorageAvailable: true,
      recentSearches: [],
      allowedKeys: allowedKeys
    }, initialState);
  }

  recent_searches_store__createClass(RecentSearchesStore, [{
    key: 'addRecentSearch',
    value: function addRecentSearch(newSearch) {
      this.setRecentSearches([newSearch].concat(this.state.recentSearches));

      return this.state.recentSearches;
    }
  }, {
    key: 'setRecentSearches',
    value: function setRecentSearches() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var trimmedSearches = searches.map(function (search) {
        return search.trim();
      });
      this.state.recentSearches = underscore_default.a.uniq(trimmedSearches).slice(0, 5);
      return this.state.recentSearches;
    }
  }]);

  return RecentSearchesStore;
}();

/* harmony default export */ var recent_searches_store = (recent_searches_store_RecentSearchesStore);
// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service_error.js
function recent_searches_service_error__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentSearchesServiceError = function RecentSearchesServiceError(message) {
  recent_searches_service_error__classCallCheck(this, RecentSearchesServiceError);

  this.name = 'RecentSearchesServiceError';
  this.message = message || 'Recent Searches Service is unavailable';
};

// Can't use `extends` for builtin prototypes and get true inheritance yet


RecentSearchesServiceError.prototype = Error.prototype;

/* harmony default export */ var recent_searches_service_error = (RecentSearchesServiceError);
// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./filtered_search/services/recent_searches_service.js
var recent_searches_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function recent_searches_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var recent_searches_service_RecentSearchesService = function () {
  function RecentSearchesService() {
    var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'issuable-recent-searches';

    recent_searches_service__classCallCheck(this, RecentSearchesService);

    this.localStorageKey = localStorageKey;
  }

  recent_searches_service__createClass(RecentSearchesService, [{
    key: 'fetch',
    value: function fetch() {
      if (!RecentSearchesService.isAvailable()) {
        var error = new recent_searches_service_error();
        return Promise.reject(error);
      }

      var input = window.localStorage.getItem(this.localStorageKey);

      var searches = [];
      if (input && input.length > 0) {
        try {
          searches = JSON.parse(input);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      return Promise.resolve(searches);
    }
  }, {
    key: 'save',
    value: function save() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!RecentSearchesService.isAvailable()) return;

      window.localStorage.setItem(this.localStorageKey, JSON.stringify(searches));
    }
  }], [{
    key: 'isAvailable',
    value: function isAvailable() {
      return accessor["a" /* default */].isLocalStorageAccessSafe();
    }
  }]);

  return RecentSearchesService;
}();

/* harmony default export */ var recent_searches_service = (recent_searches_service_RecentSearchesService);
// EXTERNAL MODULE: ./lib/utils/dom_utils.js
var dom_utils = __webpack_require__("./lib/utils/dom_utils.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_dropdown_manager.js + 8 modules
var filtered_search_dropdown_manager = __webpack_require__("./filtered_search/filtered_search_dropdown_manager.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_visual_tokens.js + 1 modules
var filtered_search_visual_tokens = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");

// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./filtered_search/filtered_search_manager.js
var filtered_search_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

















var filtered_search_manager_FilteredSearchManager = function () {
  function FilteredSearchManager(_ref) {
    var page = _ref.page,
        _ref$isGroup = _ref.isGroup,
        isGroup = _ref$isGroup === undefined ? false : _ref$isGroup,
        _ref$isGroupAncestor = _ref.isGroupAncestor,
        isGroupAncestor = _ref$isGroupAncestor === undefined ? false : _ref$isGroupAncestor,
        _ref$isGroupDecendent = _ref.isGroupDecendent,
        isGroupDecendent = _ref$isGroupDecendent === undefined ? false : _ref$isGroupDecendent,
        _ref$filteredSearchTo = _ref.filteredSearchTokenKeys,
        filteredSearchTokenKeys = _ref$filteredSearchTo === undefined ? filtered_search_token_keys["a" /* default */] : _ref$filteredSearchTo,
        _ref$stateFiltersSele = _ref.stateFiltersSelector,
        stateFiltersSelector = _ref$stateFiltersSele === undefined ? '.issues-state-filters' : _ref$stateFiltersSele;

    filtered_search_manager__classCallCheck(this, FilteredSearchManager);

    this.isGroup = isGroup;
    this.isGroupAncestor = isGroupAncestor;
    this.isGroupDecendent = isGroupDecendent;
    this.states = ['opened', 'closed', 'merged', 'all'];

    this.page = page;
    this.container = container["a" /* default */].container;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.filteredSearchInputForm = this.filteredSearchInput.form;
    this.clearSearchButton = this.container.querySelector('.clear-search');
    this.tokensContainer = this.container.querySelector('.tokens-container');
    this.filteredSearchTokenKeys = filteredSearchTokenKeys;
    this.stateFiltersSelector = stateFiltersSelector;
    this.recentsStorageKeyNames = {
      issues: 'issue-recent-searches',
      merge_requests: 'merge-request-recent-searches'
    };

    this.recentSearchesStore = new recent_searches_store({
      isLocalStorageAvailable: recent_searches_service.isAvailable(),
      allowedKeys: this.filteredSearchTokenKeys.getKeys()
    });
    this.searchHistoryDropdownElement = document.querySelector('.js-filtered-search-history-dropdown');
    var fullPath = this.searchHistoryDropdownElement ? this.searchHistoryDropdownElement.dataset.fullPath : 'project';
    var recentSearchesKey = fullPath + '-' + this.recentsStorageKeyNames[this.page];
    this.recentSearchesService = new recent_searches_service(recentSearchesKey);
  }

  filtered_search_manager__createClass(FilteredSearchManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      // Fetch recent searches from localStorage
      this.fetchingRecentSearchesPromise = this.recentSearchesService.fetch().catch(function (error) {
        if (error.name === 'RecentSearchesServiceError') return undefined;
        // eslint-disable-next-line no-new
        new flash["a" /* default */]('An error occurred while parsing recent searches');
        // Gracefully fail to empty array
        return [];
      }).then(function (searches) {
        if (!searches) {
          return;
        }

        // Put any searches that may have come in before
        // we fetched the saved searches ahead of the already saved ones
        var resultantSearches = _this.recentSearchesStore.setRecentSearches(_this.recentSearchesStore.state.recentSearches.concat(searches));
        _this.recentSearchesService.save(resultantSearches);
      });

      if (this.filteredSearchInput) {
        this.tokenizer = filtered_search_tokenizer["a" /* default */];
        this.dropdownManager = new filtered_search_dropdown_manager["a" /* default */]({
          baseEndpoint: this.filteredSearchInput.getAttribute('data-base-endpoint') || '',
          tokenizer: this.tokenizer,
          page: this.page,
          isGroup: this.isGroup,
          isGroupAncestor: this.isGroupAncestor,
          filteredSearchTokenKeys: this.filteredSearchTokenKeys
        });

        this.recentSearchesRoot = new recent_searches_root(this.recentSearchesStore, this.recentSearchesService, this.searchHistoryDropdownElement);
        this.recentSearchesRoot.init();

        this.bindEvents();
        this.loadSearchParamsFromURL();
        this.dropdownManager.setDropdown();
        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);

      if (this.recentSearchesRoot) {
        this.recentSearchesRoot.destroy();
      }
    }
  }, {
    key: 'bindStateEvents',
    value: function bindStateEvents() {
      var _this2 = this;

      this.stateFilters = document.querySelector('.container-fluid ' + this.stateFiltersSelector);

      if (this.stateFilters) {
        this.searchStateWrapper = this.searchState.bind(this);

        this.applyToStateFilters(function (filterEl) {
          filterEl.addEventListener('click', _this2.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'unbindStateEvents',
    value: function unbindStateEvents() {
      var _this3 = this;

      if (this.stateFilters) {
        this.applyToStateFilters(function (filterEl) {
          filterEl.removeEventListener('click', _this3.searchStateWrapper);
        });
      }
    }
  }, {
    key: 'applyToStateFilters',
    value: function applyToStateFilters(callback) {
      var _this4 = this;

      this.stateFilters.querySelectorAll('a[data-state]').forEach(function (filterEl) {
        if (_this4.states.indexOf(filterEl.dataset.state) > -1) {
          callback(filterEl);
        }
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
      this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
      this.handleInputPlaceholderWrapper = this.handleInputPlaceholder.bind(this);
      this.handleInputVisualTokenWrapper = this.handleInputVisualToken.bind(this);
      this.checkForEnterWrapper = this.checkForEnter.bind(this);
      this.onClearSearchWrapper = this.onClearSearch.bind(this);
      this.checkForBackspaceWrapper = this.checkForBackspace.call(this);
      this.removeSelectedTokenKeydownWrapper = this.removeSelectedTokenKeydown.bind(this);
      this.unselectEditTokensWrapper = this.unselectEditTokens.bind(this);
      this.editTokenWrapper = this.editToken.bind(this);
      this.tokenChange = this.tokenChange.bind(this);
      this.addInputContainerFocusWrapper = this.addInputContainerFocus.bind(this);
      this.removeInputContainerFocusWrapper = this.removeInputContainerFocus.bind(this);
      this.onrecentSearchesItemSelectedWrapper = this.onrecentSearchesItemSelected.bind(this);
      this.removeTokenWrapper = this.removeToken.bind(this);

      this.filteredSearchInputForm.addEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.addEventListener('click', this.tokenChange);
      this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.addEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.addEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.addEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.addEventListener('click', this.onClearSearchWrapper);
      document.addEventListener('click', this.unselectEditTokensWrapper);
      document.addEventListener('click', this.removeInputContainerFocusWrapper);
      document.addEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$on('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.bindStateEvents();
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.filteredSearchInputForm.removeEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.removeEventListener('click', this.tokenChange);
      this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.removeEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.removeEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.removeEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.removeEventListener('click', this.onClearSearchWrapper);
      document.removeEventListener('click', this.unselectEditTokensWrapper);
      document.removeEventListener('click', this.removeInputContainerFocusWrapper);
      document.removeEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      event_hub.$off('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.unbindStateEvents();
    }
  }, {
    key: 'checkForBackspace',
    value: function checkForBackspace() {
      var _this5 = this;

      var backspaceCount = 0;

      // closure for keeping track of the number of backspace keystrokes
      return function (e) {
        // 8 = Backspace Key
        // 46 = Delete Key
        if (e.keyCode === 8 || e.keyCode === 46) {
          var _FilteredSearchVisual = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
              lastVisualToken = _FilteredSearchVisual.lastVisualToken;

          var _DropdownUtils$getVis = dropdown_utils["a" /* default */].getVisualTokenValues(lastVisualToken),
              tokenName = _DropdownUtils$getVis.tokenName,
              tokenValue = _DropdownUtils$getVis.tokenValue;

          var canEdit = tokenName && _this5.canEdit && _this5.canEdit(tokenName, tokenValue);

          if (_this5.filteredSearchInput.value === '' && lastVisualToken && canEdit) {
            backspaceCount += 1;

            if (backspaceCount === 2) {
              backspaceCount = 0;
              _this5.filteredSearchInput.value = filtered_search_visual_tokens["a" /* default */].getLastTokenPartial();
              filtered_search_visual_tokens["a" /* default */].removeLastTokenPartial();
            }
          }

          // Reposition dropdown so that it is aligned with cursor
          _this5.dropdownManager.updateCurrentDropdownOffset();
        } else {
          backspaceCount = 0;
        }
      };
    }
  }, {
    key: 'checkForEnter',
    value: function checkForEnter(e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        var selectionStart = this.filteredSearchInput.selectionStart;

        e.preventDefault();
        this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
      }

      if (e.keyCode === 13) {
        var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
        var dropdownEl = dropdown.element;
        var activeElements = dropdownEl.querySelectorAll('.droplab-item-active');

        e.preventDefault();

        if (!activeElements.length) {
          if (this.isHandledAsync) {
            e.stopImmediatePropagation();

            this.filteredSearchInput.blur();
            this.dropdownManager.resetDropdowns();
          } else {
            // Prevent droplab from opening dropdown
            this.dropdownManager.destroyDroplab();
          }

          this.search();
        }
      }
    }
  }, {
    key: 'addInputContainerFocus',
    value: function addInputContainerFocus() {
      Object(dom_utils["a" /* addClassIfElementExists */])(this.filteredSearchInput.closest('.filtered-search-box'), 'focus');
    }
  }, {
    key: 'removeInputContainerFocus',
    value: function removeInputContainerFocus(e) {
      var inputContainer = this.filteredSearchInput.closest('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInDynamicFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementInStaticFilterDropdown = e.target.closest('ul[data-dropdown]') !== null;

      if (!isElementInFilteredSearch && !isElementInDynamicFilterDropdown && !isElementInStaticFilterDropdown && inputContainer) {
        inputContainer.classList.remove('focus');
      }
    }
  }, {
    key: 'removeToken',
    value: function removeToken(e) {
      var removeButtonSelected = e.target.closest('.remove-token');

      if (removeButtonSelected) {
        e.preventDefault();
        // Prevent editToken from being triggered after token is removed
        e.stopImmediatePropagation();

        var button = e.target.closest('.selectable');
        filtered_search_visual_tokens["a" /* default */].selectToken(button, true);
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'unselectEditTokens',
    value: function unselectEditTokens(e) {
      var inputContainer = this.container.querySelector('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementTokensContainer = e.target.classList.contains('tokens-container');

      if (!isElementInFilteredSearch && !isElementInFilterDropdown || isElementTokensContainer) {
        filtered_search_visual_tokens["a" /* default */].moveInputToTheRight();
        this.dropdownManager.resetDropdowns();
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(e) {
      var token = e.target.closest('.js-visual-token');
      var sanitizedTokenName = token && token.querySelector('.name').textContent.trim();
      var canEdit = this.canEdit && this.canEdit(sanitizedTokenName);

      if (token && canEdit) {
        e.preventDefault();
        e.stopPropagation();
        filtered_search_visual_tokens["a" /* default */].editToken(token);
        this.tokenChange();
      }
    }
  }, {
    key: 'toggleClearSearchButton',
    value: function toggleClearSearchButton() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var hidden = 'hidden';
      var hasHidden = this.clearSearchButton.classList.contains(hidden);

      if (query.length === 0 && !hasHidden) {
        this.clearSearchButton.classList.add(hidden);
      } else if (query.length && hasHidden) {
        this.clearSearchButton.classList.remove(hidden);
      }
    }
  }, {
    key: 'handleInputPlaceholder',
    value: function handleInputPlaceholder() {
      var query = dropdown_utils["a" /* default */].getSearchQuery();
      var placeholder = 'Search or filter results...';
      var currentPlaceholder = this.filteredSearchInput.placeholder;

      if (query.length === 0 && currentPlaceholder !== placeholder) {
        this.filteredSearchInput.placeholder = placeholder;
      } else if (query.length > 0 && currentPlaceholder !== '') {
        this.filteredSearchInput.placeholder = '';
      }
    }
  }, {
    key: 'removeSelectedTokenKeydown',
    value: function removeSelectedTokenKeydown(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      filtered_search_visual_tokens["a" /* default */].removeSelectedToken();
      this.handleInputPlaceholder();
      this.toggleClearSearchButton();
      this.dropdownManager.updateCurrentDropdownOffset();
    }
  }, {
    key: 'onClearSearch',
    value: function onClearSearch(e) {
      e.preventDefault();
      this.clearSearch();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var _this6 = this;

      this.filteredSearchInput.value = '';

      var removeElements = [];

      [].forEach.call(this.tokensContainer.children, function (t) {
        var canClearToken = t.classList.contains('js-visual-token');

        if (canClearToken) {
          var _DropdownUtils$getVis2 = dropdown_utils["a" /* default */].getVisualTokenValues(t),
              tokenName = _DropdownUtils$getVis2.tokenName,
              tokenValue = _DropdownUtils$getVis2.tokenValue;

          canClearToken = _this6.canEdit && _this6.canEdit(tokenName, tokenValue);
        }

        if (canClearToken) {
          removeElements.push(t);
        }
      });

      removeElements.forEach(function (el) {
        el.parentElement.removeChild(el);
      });

      this.clearSearchButton.classList.add('hidden');
      this.handleInputPlaceholder();

      this.dropdownManager.resetDropdowns();

      if (this.isHandledAsync) {
        this.search();
      }
    }
  }, {
    key: 'handleInputVisualToken',
    value: function handleInputVisualToken() {
      var input = this.filteredSearchInput;

      var _tokenizer$processTok = this.tokenizer.processTokens(input.value, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok.tokens,
          searchToken = _tokenizer$processTok.searchToken;

      var _FilteredSearchVisual2 = filtered_search_visual_tokens["a" /* default */].getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      if (isLastVisualTokenValid) {
        tokens.forEach(function (t) {
          input.value = input.value.replace(t.key + ':' + t.symbol + t.value, '');
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(t.key, '' + t.symbol + t.value);
        });

        var fragments = searchToken.split(':');
        if (fragments.length > 1) {
          var inputValues = fragments[0].split(' ');
          var tokenKey = underscore_default.a.last(inputValues);

          if (inputValues.length > 1) {
            inputValues.pop();
            var searchTerms = inputValues.join(' ');

            input.value = input.value.replace(searchTerms, '');
            filtered_search_visual_tokens["a" /* default */].addSearchVisualToken(searchTerms);
          }

          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenKey);
          input.value = input.value.replace(tokenKey + ':', '');
        }
      } else {
        // Keep listening to token until we determine that the user is done typing the token value
        var valueCompletedRegex = /([~%@]{0,1}".+")|([~%@]{0,1}'.+')|^((?![~%@]')(?![~%@]")(?!')(?!")).*/g;

        if (searchToken.match(valueCompletedRegex) && input.value[input.value.length - 1] === ' ') {
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(searchToken);

          // Trim the last space as seen in the if statement above
          input.value = input.value.replace(searchToken, '').trim();
        }
      }
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.search();
    }
  }, {
    key: 'saveCurrentSearchQuery',
    value: function saveCurrentSearchQuery() {
      var _this7 = this;

      // Don't save before we have fetched the already saved searches
      this.fetchingRecentSearchesPromise.then(function () {
        var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();
        if (searchQuery.length > 0) {
          var resultantSearches = _this7.recentSearchesStore.addRecentSearch(searchQuery);
          _this7.recentSearchesService.save(resultantSearches);
        }
      }).catch(function () {
        // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
      });
    }

    // allows for modifying params array when a param can't be included in the URL (e.g. Service Desk)

  }, {
    key: 'getAllParams',
    value: function getAllParams(urlParams) {
      return this.modifyUrlParams ? this.modifyUrlParams(urlParams) : urlParams;
    }
  }, {
    key: 'loadSearchParamsFromURL',
    value: function loadSearchParamsFromURL() {
      var _this8 = this;

      var urlParams = Object(common_utils["l" /* getUrlParamsArray */])();
      var params = this.getAllParams(urlParams);
      var usernameParams = this.getUsernameParams();
      var hasFilteredSearch = false;

      params.forEach(function (p) {
        var split = p.split('=');
        var keyParam = decodeURIComponent(split[0]);
        var value = split[1];

        // Check if it matches edge conditions listed in this.filteredSearchTokenKeys
        var condition = _this8.filteredSearchTokenKeys.searchByConditionUrl(p);

        if (condition) {
          hasFilteredSearch = true;
          var canEdit = _this8.canEdit && _this8.canEdit(condition.tokenKey);
          filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(condition.tokenKey, condition.value, canEdit);
        } else {
          // Sanitize value since URL converts spaces into +
          // Replace before decode so that we know what was originally + versus the encoded +
          var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
          var match = _this8.filteredSearchTokenKeys.searchByKeyParam(keyParam);

          if (match) {
            // Use lastIndexOf because the token key is allowed to contain underscore
            // e.g. 'my_reaction' is the token key of 'my_reaction_emoji'
            var lastIndexOf = keyParam.lastIndexOf('_');
            var sanitizedKey = lastIndexOf !== -1 ? keyParam.slice(0, lastIndexOf) : keyParam;
            // Replace underscore with hyphen in the sanitizedkey.
            // e.g. 'my_reaction' => 'my-reaction'
            sanitizedKey = sanitizedKey.replace('_', '-');
            var symbol = match.symbol;
            var quotationsToUse = '';

            if (sanitizedValue.indexOf(' ') !== -1) {
              // Prefer ", but use ' if required
              quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
            }

            hasFilteredSearch = true;
            var _canEdit = _this8.canEdit && _this8.canEdit(sanitizedKey, sanitizedValue);
            filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(sanitizedKey, '' + symbol + quotationsToUse + sanitizedValue + quotationsToUse, _canEdit);
          } else if (!match && keyParam === 'assignee_id') {
            var id = parseInt(value, 10);
            if (usernameParams[id]) {
              hasFilteredSearch = true;
              var tokenName = 'assignee';
              var _canEdit2 = _this8.canEdit && _this8.canEdit(tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenName, '@' + usernameParams[id], _canEdit2);
            }
          } else if (!match && keyParam === 'author_id') {
            var _id = parseInt(value, 10);
            if (usernameParams[_id]) {
              hasFilteredSearch = true;
              var _tokenName = 'author';
              var _canEdit3 = _this8.canEdit && _this8.canEdit(_tokenName);
              filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(_tokenName, '@' + usernameParams[_id], _canEdit3);
            }
          } else if (!match && keyParam === 'search') {
            hasFilteredSearch = true;
            _this8.filteredSearchInput.value = sanitizedValue;
          }
        }
      });

      this.saveCurrentSearchQuery();

      if (hasFilteredSearch) {
        this.clearSearchButton.classList.remove('hidden');
        this.handleInputPlaceholder();
      }
    }
  }, {
    key: 'searchState',
    value: function searchState(e) {
      e.preventDefault();
      var target = e.currentTarget;
      // remove focus outline after click
      target.blur();

      var state = target.dataset && target.dataset.state;

      if (state) {
        this.search(state);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var _this9 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var paths = [];
      var searchQuery = dropdown_utils["a" /* default */].getSearchQuery();

      this.saveCurrentSearchQuery();

      var _tokenizer$processTok2 = this.tokenizer.processTokens(searchQuery, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok2.tokens,
          searchToken = _tokenizer$processTok2.searchToken;

      var currentState = state || Object(common_utils["i" /* getParameterByName */])('state') || 'opened';
      paths.push('state=' + currentState);

      tokens.forEach(function (token) {
        var condition = _this9.filteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

        var _ref2 = _this9.filteredSearchTokenKeys.searchByKey(token.key) || {},
            param = _ref2.param;
        // Replace hyphen with underscore to use as request parameter
        // e.g. 'my-reaction' => 'my_reaction'


        var underscoredKey = token.key.replace('-', '_');
        var keyParam = param ? underscoredKey + '_' + param : underscoredKey;
        var tokenPath = '';

        if (condition) {
          tokenPath = condition.url;
        } else {
          var tokenValue = token.value;

          if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
            tokenValue = tokenValue.slice(1, tokenValue.length - 1);
          }

          tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
        }

        paths.push(tokenPath);
      });

      if (searchToken) {
        var sanitized = searchToken.split(' ').map(function (t) {
          return encodeURIComponent(t);
        }).join('+');
        paths.push('search=' + sanitized);
      }

      var parameterizedUrl = '?scope=all&utf8=%E2%9C%93&' + paths.join('&');

      if (this.updateObject) {
        this.updateObject(parameterizedUrl);
      } else {
        Object(url_utility["g" /* visitUrl */])(parameterizedUrl);
      }
    }
  }, {
    key: 'getUsernameParams',
    value: function getUsernameParams() {
      var usernamesById = {};
      try {
        var attribute = this.filteredSearchInput.getAttribute('data-username-params');
        JSON.parse(attribute).forEach(function (user) {
          usernamesById[user.id] = user.username;
        });
      } catch (e) {
        // do nothing
      }
      return usernamesById;
    }
  }, {
    key: 'tokenChange',
    value: function tokenChange() {
      var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];

      if (dropdown) {
        var currentDropdownRef = dropdown.reference;

        this.setDropdownWrapper();
        currentDropdownRef.dispatchInputEvent();
      }
    }
  }, {
    key: 'onrecentSearchesItemSelected',
    value: function onrecentSearchesItemSelected(text) {
      this.clearSearch();
      this.filteredSearchInput.value = text;
      this.filteredSearchInput.dispatchEvent(new CustomEvent('input'));
      this.search();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return true;
    }
  }]);

  return FilteredSearchManager;
}();

/* harmony default export */ var filtered_search_manager = __webpack_exports__["a"] = (filtered_search_manager_FilteredSearchManager);

/***/ }),

/***/ "./issuable_bulk_update_actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */




/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        container = _ref.container,
        form = _ref.form,
        issues = _ref.issues,
        prefixId = _ref.prefixId;

    this.prefixId = prefixId || 'issue_';
    this.form = form || this.getElement('.bulk-update');
    this.$labelDropdown = this.form.find('.js-label-select');
    this.issues = issues || this.getElement('.issues-list .issue');
    this.willUpdateLabels = false;
    this.bindEvents();
  },
  bindEvents: function bindEvents() {
    return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
  },
  onFormSubmit: function onFormSubmit(e) {
    e.preventDefault();
    return this.submit();
  },
  submit: function submit() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */][this.form.attr('method')](this.form.attr('action'), this.getFormDataAsObject()).then(function () {
      return window.location.reload();
    }).catch(function () {
      return _this.onFormSubmitFailure();
    });
  },
  onFormSubmitFailure: function onFormSubmitFailure() {
    this.form.find('[type="submit"]').enable();
    return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */]("Issue update failed");
  },
  getSelectedIssues: function getSelectedIssues() {
    return this.issues.has('.selected_issue:checked');
  },
  getLabelsFromSelection: function getLabelsFromSelection() {
    var labels = [];
    this.getSelectedIssues().map(function () {
      var labelsData = $(this).data('labels');
      if (labelsData) {
        return labelsData.map(function (labelId) {
          if (labels.indexOf(labelId) === -1) {
            return labels.push(labelId);
          }
        });
      }
    });
    return labels;
  },


  /**
   * Will return only labels that were marked previously and the user has unmarked
   * @return {Array} Label IDs
   */

  getUnmarkedIndeterminedLabels: function getUnmarkedIndeterminedLabels() {
    var result = [];
    var labelsToKeep = this.$labelDropdown.data('indeterminate');

    this.getLabelsFromSelection().forEach(function (id) {
      if (labelsToKeep.indexOf(id) === -1) {
        result.push(id);
      }
    });

    return result;
  },


  /**
   * Simple form serialization, it will return just what we need
   * Returns key/value pairs from form data
   */

  getFormDataAsObject: function getFormDataAsObject() {
    var formData = {
      update: {
        state_event: this.form.find('input[name="update[state_event]"]').val(),
        // For Merge Requests
        assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
        // For Issues
        assignee_ids: [this.form.find('input[name="update[assignee_ids][]"]').val()],
        milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
        issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
        subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
        add_label_ids: [],
        remove_label_ids: []
      }
    };
    if (this.willUpdateLabels) {
      formData.update.add_label_ids = this.$labelDropdown.data('marked');
      formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
    }
    return formData;
  },
  setOriginalDropdownData: function setOriginalDropdownData() {
    var $labelSelect = $('.bulk-update .js-label-select');
    $labelSelect.data('common', this.getOriginalCommonIds());
    $labelSelect.data('marked', this.getOriginalMarkedIds());
    $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
  },


  // From issuable's initial bulk selection
  getOriginalCommonIds: function getOriginalCommonIds() {
    var _this2 = this;

    var labelIds = [];

    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalMarkedIds: function getOriginalMarkedIds() {
    var _this3 = this;

    var labelIds = [];
    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalIndeterminateIds: function getOriginalIndeterminateIds() {
    var _this4 = this;

    var uniqueIds = [];
    var labelIds = [];
    var issuableLabels = [];

    // Collect unique label IDs for all checked issues
    this.getElement('.selected_issue:checked').each(function (i, el) {
      issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
      issuableLabels.forEach(function (labelId) {
        // Store unique IDs
        if (uniqueIds.indexOf(labelId) === -1) {
          uniqueIds.push(labelId);
        }
      });
      // Store array of IDs per issuable
      labelIds.push(issuableLabels);
    });
    // Add uniqueIds to add it as argument for _.intersection
    labelIds.unshift(uniqueIds);
    // Return IDs that are present but not in all selected issueables
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.difference(uniqueIds, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds));
  },
  getElement: function getElement(selector) {
    this.scopeEl = this.scopeEl || $('.content');
    return this.scopeEl.find(selector);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_bulk_update_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__issue_status_select__ = __webpack_require__("./issue_status_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscription_select__ = __webpack_require__("./subscription_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__labels_select__ = __webpack_require__("./labels_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-new */







var HIDDEN_CLASS = 'hidden';
var DISABLED_CONTENT_CLASS = 'disabled-content';
var SIDEBAR_EXPANDED_CLASS = 'right-sidebar-expanded issuable-bulk-update-sidebar';
var SIDEBAR_COLLAPSED_CLASS = 'right-sidebar-collapsed issuable-bulk-update-sidebar';

var IssuableBulkUpdateSidebar = function () {
  function IssuableBulkUpdateSidebar() {
    _classCallCheck(this, IssuableBulkUpdateSidebar);

    this.initDomElements();
    this.bindEvents();
    this.initDropdowns();
    this.setupBulkUpdateActions();
  }

  _createClass(IssuableBulkUpdateSidebar, [{
    key: 'initDomElements',
    value: function initDomElements() {
      this.$page = $('.layout-page');
      this.$sidebar = $('.right-sidebar');
      this.$sidebarInnerContainer = this.$sidebar.find('.issuable-sidebar');
      this.$bulkEditCancelBtn = $('.js-bulk-update-menu-hide');
      this.$bulkEditSubmitBtn = $('.update-selected-issues');
      this.$bulkUpdateEnableBtn = $('.js-bulk-update-toggle');
      this.$otherFilters = $('.issues-other-filters');
      this.$checkAllContainer = $('.check-all-holder');
      this.$issueChecks = $('.issue-check');
      this.$issuesList = $('.selected_issue');
      this.$issuableIdsInput = $('#update_issuable_ids');
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.$bulkUpdateEnableBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, true);
      });
      this.$bulkEditCancelBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, false);
      });
      this.$checkAllContainer.on('click', function (e) {
        return _this.selectAll(e);
      });
      this.$issuesList.on('change', function () {
        return _this.updateFormState();
      });
      this.$bulkEditSubmitBtn.on('click', function () {
        return _this.prepForSubmit();
      });
      this.$checkAllContainer.on('click', function () {
        return _this.updateFormState();
      });
    }
  }, {
    key: 'initDropdowns',
    value: function initDropdowns() {
      new __WEBPACK_IMPORTED_MODULE_4__labels_select__["a" /* default */]();
      new __WEBPACK_IMPORTED_MODULE_1__milestone_select__["a" /* default */]();
      Object(__WEBPACK_IMPORTED_MODULE_2__issue_status_select__["a" /* default */])();
      Object(__WEBPACK_IMPORTED_MODULE_3__subscription_select__["a" /* default */])();
    }
  }, {
    key: 'setupBulkUpdateActions',
    value: function setupBulkUpdateActions() {
      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'updateFormState',
    value: function updateFormState() {
      var noCheckedIssues = !$('.selected_issue:checked').length;

      this.toggleSubmitButtonDisabled(noCheckedIssues);
      this.updateSelectedIssuableIds();

      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'prepForSubmit',
    value: function prepForSubmit() {
      var _this2 = this;

      // if submit button is disabled, submission is blocked. This ensures we disable after
      // form submission is carried out
      setTimeout(function () {
        return _this2.$bulkEditSubmitBtn.disable();
      });
      this.updateSelectedIssuableIds();
    }
  }, {
    key: 'toggleBulkEdit',
    value: function toggleBulkEdit(e, enable) {
      e.preventDefault();

      this.toggleSidebarDisplay(enable);
      this.toggleBulkEditButtonDisabled(enable);
      this.toggleOtherFiltersDisabled(enable);
      this.toggleCheckboxDisplay(enable);
    }
  }, {
    key: 'updateSelectedIssuableIds',
    value: function updateSelectedIssuableIds() {
      this.$issuableIdsInput.val(IssuableBulkUpdateSidebar.getCheckedIssueIds());
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var checkAllButtonState = this.$checkAllContainer.find('input').prop('checked');

      this.$issuesList.prop('checked', checkAllButtonState);
    }
  }, {
    key: 'toggleSidebarDisplay',
    value: function toggleSidebarDisplay(show) {
      this.$page.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$page.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
      this.$sidebarInnerContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$sidebar.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$sidebar.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
    }
  }, {
    key: 'toggleBulkEditButtonDisabled',
    value: function toggleBulkEditButtonDisabled(disable) {
      if (disable) {
        this.$bulkUpdateEnableBtn.disable();
      } else {
        this.$bulkUpdateEnableBtn.enable();
      }
    }
  }, {
    key: 'toggleCheckboxDisplay',
    value: function toggleCheckboxDisplay(show) {
      this.$checkAllContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$issueChecks.toggleClass(HIDDEN_CLASS, !show);
    }
  }, {
    key: 'toggleOtherFiltersDisabled',
    value: function toggleOtherFiltersDisabled(disable) {
      this.$otherFilters.toggleClass(DISABLED_CONTENT_CLASS, disable);
    }
  }, {
    key: 'toggleSubmitButtonDisabled',
    value: function toggleSubmitButtonDisabled(disable) {
      if (disable) {
        this.$bulkEditSubmitBtn.disable();
      } else {
        this.$bulkEditSubmitBtn.enable();
      }
    }
  }], [{
    key: 'getCheckedIssueIds',
    value: function getCheckedIssueIds() {
      var $checkedIssues = $('.selected_issue:checked');

      if ($checkedIssues.length > 0) {
        return $.map($checkedIssues, function (value) {
          return $(value).data('id');
        });
      }

      return [];
    }
  }]);

  return IssuableBulkUpdateSidebar;
}();

/* harmony default export */ __webpack_exports__["a"] = (IssuableBulkUpdateSidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_sidebar__ = __webpack_require__("./issuable_bulk_update_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var IssuableIndex = function () {
  function IssuableIndex(pagePrefix) {
    _classCallCheck(this, IssuableIndex);

    this.initBulkUpdate(pagePrefix);
    IssuableIndex.resetIncomingEmailToken();
  }

  _createClass(IssuableIndex, [{
    key: 'initBulkUpdate',
    value: function initBulkUpdate(pagePrefix) {
      var userCanBulkUpdate = $('.issues-bulk-update').length > 0;
      var alreadyInitialized = !!this.bulkUpdateSidebar;

      if (userCanBulkUpdate && !alreadyInitialized) {
        __WEBPACK_IMPORTED_MODULE_4__issuable_bulk_update_actions__["a" /* default */].init({
          prefixId: pagePrefix
        });

        this.bulkUpdateSidebar = new __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_sidebar__["a" /* default */]();
      }
    }
  }], [{
    key: 'resetIncomingEmailToken',
    value: function resetIncomingEmailToken() {
      var $resetToken = $('.incoming-email-token-reset');

      $resetToken.on('click', function (e) {
        e.preventDefault();

        $resetToken.text('resetting...');

        __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].put($resetToken.attr('href')).then(function (_ref) {
          var data = _ref.data;

          $('#issuable_email').val(data.new_address).focus();

          $resetToken.text('reset it');
        }).catch(function () {
          Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('There was an error when reseting email token.'));

          $resetToken.text('reset it');
        });
      });
    }
  }]);

  return IssuableIndex;
}();

/* harmony default export */ __webpack_exports__["a"] = (IssuableIndex);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issue_status_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = issueStatusSelect;
function issueStatusSelect() {
  $('.js-issue-status').each(function (i, el) {
    var fieldName = $(el).data('fieldName');
    return $(el).glDropdown({
      selectable: true,
      fieldName: fieldName,
      toggleLabel: function toggleLabel(selected, element, instance) {
        var label = 'Author';
        var $item = instance.dropdown.find('.is-active');
        if ($item.length) {
          label = $item.text();
        }
        return label;
      },
      clicked: function clicked(options) {
        return options.e.preventDefault();
      },
      id: function id(obj, element) {
        return $(element).data('id');
      }
    });
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_label__ = __webpack_require__("./create_label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flash__ = __webpack_require__("./flash.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */








var LabelsSelect = function () {
  function LabelsSelect(els) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LabelsSelect);

    var _this, $els;
    _this = this;

    $els = $(els);

    if (!els) {
      $els = $('.js-label-select');
    }

    $els.each(function (i, dropdown) {
      var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
      $dropdown = $(dropdown);
      $dropdownContainer = $dropdown.closest('.labels-filter');
      $toggleText = $dropdown.find('.dropdown-toggle-text');
      namespacePath = $dropdown.data('namespacePath');
      projectPath = $dropdown.data('projectPath');
      labelUrl = $dropdown.data('labels');
      issueUpdateURL = $dropdown.data('issueUpdate');
      selectedLabel = $dropdown.data('selected');
      if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
        selectedLabel = selectedLabel.split(',');
      }
      showNo = $dropdown.data('showNo');
      showAny = $dropdown.data('showAny');
      showMenuAbove = $dropdown.data('showMenuAbove');
      defaultLabel = $dropdown.data('defaultLabel');
      abilityName = $dropdown.data('abilityName');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      $form = $dropdown.closest('form, .js-issuable-update');
      $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
      $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
      $value = $block.find('.value');
      $loading = $block.find('.block-loading').fadeOut();
      fieldName = $dropdown.data('fieldName');
      useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
      propertyName = useId ? 'id' : 'title';
      initialSelected = $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]').map(function () {
        return this.value;
      }).get();
      var handleClick = options.handleClick;

      $sidebarLabelTooltip.tooltip();

      if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
        new __WEBPACK_IMPORTED_MODULE_5__create_label__["a" /* default */]($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
      }

      saveLabelData = function saveLabelData() {
        var data, selected;
        selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
          return this.value;
        }).get();

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(initialSelected, selected)) return;
        initialSelected = selected;

        data = {};
        data[abilityName] = {};
        data[abilityName].label_ids = selected;
        if (!selected.length) {
          data[abilityName].label_ids = [''];
        }
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].put(issueUpdateURL, data).then(function (_ref) {
          var data = _ref.data;

          var labelCount, template, labelTooltipTitle, labelTitles;
          $loading.fadeOut();
          $dropdown.trigger('loaded.gl.dropdown');
          $selectbox.hide();
          data.issueUpdateURL = issueUpdateURL;
          labelCount = 0;
          if (data.labels.length && issueUpdateURL) {
            template = LabelsSelect.getLabelTemplate({
              labels: data.labels,
              issueUpdateURL: issueUpdateURL
            });
            labelCount = data.labels.length;
          } else {
            template = '<span class="no-value">None</span>';
          }
          $value.removeAttr('style').html(template);
          $sidebarCollapsedValue.text(labelCount);

          if (data.labels.length) {
            labelTitles = data.labels.map(function (label) {
              return label.title;
            });

            if (labelTitles.length > 5) {
              labelTitles = labelTitles.slice(0, 5);
              labelTitles.push('and ' + (data.labels.length - 5) + ' more');
            }

            labelTooltipTitle = labelTitles.join(', ');
          } else {
            labelTooltipTitle = '';
            $sidebarLabelTooltip.tooltip('destroy');
          }

          $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

          $('.has-tooltip', $value).tooltip({
            container: 'body'
          });
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error saving label update.'));
        });
      };
      $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(labelUrl).then(function (res) {
            var data = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(res.data).groupBy(function (label) {
              return label.title;
            }).map(function (label) {
              var color;
              color = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(label, function (dup) {
                return dup.color;
              });
              return {
                id: label[0].id,
                title: label[0].title,
                color: color,
                duplicate: color.length > 1
              };
            }).value();
            if ($dropdown.hasClass('js-extra-options')) {
              var extraData = [];
              if (showNo) {
                extraData.unshift({
                  id: 0,
                  title: '没有标记'
                });
              }
              if (showAny) {
                extraData.unshift({
                  isAny: true,
                  title: '所有标记'
                });
              }
              if (extraData.length) {
                extraData.push('divider');
                data = extraData.concat(data);
              }
            }

            callback(data);
            if (showMenuAbove) {
              $dropdown.data('glDropdown').positionMenuAbove();
            }
          }).catch(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error fetching labels.'));
          });
        },
        renderRow: function renderRow(label, instance) {
          var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
          $li = $('<li>');
          $a = $('<a href="#">');
          selectedClass = [];
          removesAll = label.id <= 0 || label.id == null;
          if ($dropdown.hasClass('js-filter-bulk-update')) {
            indeterminate = $dropdown.data('indeterminate') || [];
            marked = $dropdown.data('marked') || [];

            if (indeterminate.indexOf(label.id) !== -1) {
              selectedClass.push('is-indeterminate');
            }

            if (marked.indexOf(label.id) !== -1) {
              // Remove is-indeterminate class if the item will be marked as active
              i = selectedClass.indexOf('is-indeterminate');
              if (i !== -1) {
                selectedClass.splice(i, 1);
              }
              selectedClass.push('is-active');
            }
          } else {
            if (this.id(label)) {
              dropdownName = $dropdown.data('fieldName');
              dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

              if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                selectedClass.push('is-active');
              }
            }

            if ($dropdown.hasClass('js-multiselect') && removesAll) {
              selectedClass.push('dropdown-clear-active');
            }
          }
          if (label.duplicate) {
            color = __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__["a" /* default */].duplicateLabelColor(label.color);
          } else {
            if (label.color != null) {
              color = label.color[0];
            }
          }
          if (color) {
            colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
          } else {
            colorEl = '';
          }
          // We need to identify which items are actually labels
          if (label.id) {
            selectedClass.push('label-item');
            $a.attr('data-label-id', label.id);
          }
          $a.addClass(selectedClass.join(' ')).html(colorEl + ' ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(label.title));
          // Return generated html
          return $li.html($a).prop('outerHTML');
        },
        search: {
          fields: ['title']
        },
        selectable: true,
        filterable: true,
        selected: $dropdown.data('selected') || [],
        toggleLabel: function toggleLabel(selected, el) {
          var $dropdownParent = $dropdown.parent();
          var $dropdownInputField = $dropdownParent.find('.dropdown-input-field');
          var isSelected = el !== null ? el.hasClass('is-active') : false;
          var title = selected.title;
          var selectedLabels = this.selected;

          if ($dropdownInputField.length && $dropdownInputField.val().length) {
            $dropdownParent.find('.dropdown-input-clear').trigger('click');
          }

          if (selected.id === 0) {
            this.selected = [];
            return '无标记';
          } else if (isSelected) {
            this.selected.push(title);
          } else {
            var index = this.selected.indexOf(title);
            this.selected.splice(index, 1);
          }

          if (selectedLabels.length === 1) {
            return selectedLabels;
          } else if (selectedLabels.length) {
            return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
          } else {
            return defaultLabel;
          }
        },
        fieldName: $dropdown.data('fieldName'),
        id: function id(label) {
          if (label.id <= 0) return label.title;

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return label.id;
          }

          if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
            return label.title;
          } else {
            return label.id;
          }
        },
        hidden: function hidden() {
          var isIssueIndex, isMRIndex, page, selectedLabels;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';
          $selectbox.hide();
          // display:block overrides the hide-collapse rule
          $value.removeAttr('style');

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($('html').hasClass('issue-boards-page')) {
            return;
          }
          if ($dropdown.hasClass('js-multiselect')) {
            if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
              Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              $dropdown.closest('form').submit();
            } else {
              if (!$dropdown.hasClass('js-filter-bulk-update')) {
                saveLabelData();
              }
            }
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        vue: $dropdown.hasClass('js-issue-board-sidebar'),
        clicked: function clicked(clickEvent) {
          var $el = clickEvent.$el,
              e = clickEvent.e,
              isMarking = clickEvent.isMarking;

          var label = clickEvent.selectedObj;

          var isIssueIndex, isMRIndex, page, boardsModel;
          var fadeOutLoader = function fadeOutLoader() {
            $loading.fadeOut();
          };

          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';

          if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
            $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
          }

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($dropdown.hasClass('js-filter-bulk-update')) {
            _this.enableBulkLabelDropdown();
            _this.setDropdownData($dropdown, isMarking, label.id);
            return;
          }

          if ($dropdown.closest('.add-issues-modal').length) {
            boardsModel = gl.issueBoards.ModalStore.store.filter;
          }

          if (boardsModel) {
            if (label.isAny) {
              boardsModel['label_name'] = [];
            } else if ($el.hasClass('is-active')) {
              boardsModel['label_name'].push(label.title);
            }

            e.preventDefault();
            return;
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            if (!$dropdown.hasClass('js-multiselect')) {
              selectedLabel = label.title;
              return Issuable.filterResults($dropdown.closest('form'));
            }
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            if ($el.hasClass('is-active')) {
              gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                id: label.id,
                title: label.title,
                color: label.color[0],
                textColor: '#fff'
              }));
            } else {
              var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
              labels = labels.filter(function (selectedLabel) {
                return selectedLabel.id !== label.id;
              });
              gl.issueBoards.BoardsStore.detail.issue.labels = labels;
            }

            $loading.fadeIn();

            gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
          } else if (handleClick) {
            e.preventDefault();
            handleClick(label);
          } else {
            if ($dropdown.hasClass('js-multiselect')) {} else {
              return saveLabelData();
            }
          }
        }
      });

      // Set dropdown data
      _this.setOriginalDropdownData($dropdownContainer, $dropdown);
    });
    this.bindEvents();
  }

  _createClass(LabelsSelect, [{
    key: 'bindEvents',
    value: function bindEvents() {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'onSelectCheckboxIssue',
    value: function onSelectCheckboxIssue() {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues-bulk-update .labels-filter .dropdown-toggle-text').text('Label');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'enableBulkLabelDropdown',
    value: function enableBulkLabelDropdown() {
      __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].willUpdateLabels = true;
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setDropdownData',
    value: function setDropdownData($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setOriginalDropdownData',
    value: function setOriginalDropdownData($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    }
  }], [{
    key: 'getLabelTemplate',
    value: function getLabelTemplate(tplData) {
      // We could use ES6 template string here
      // and properly indent markup for readability
      // but that also introduces unintended white-space
      // so best approach is to use traditional way of
      // concatenation
      // see: http://2ality.com/2016/05/template-literal-whitespace.html#joining-arrays
      var tpl = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(['<% _.each(labels, function(label){ %>', '<a href="<%- issueUpdateURL.slice(0, issueUpdateURL.lastIndexOf("/")) %>?label_name[]=<%- encodeURIComponent(label.title) %>">', '<span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;">', '<%- label.title %>', '</span>', '</a>', '<% }); %>'].join(''));

      return tpl(tplData);
    }
  }]);

  return LabelsSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (LabelsSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERED_SEARCH; });
/* eslint-disable import/prefer-default-export  */

var FILTERED_SEARCH = {
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues'
};

/***/ }),

/***/ "./pages/projects/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISSUABLE_INDEX; });
/* eslint-disable import/prefer-default-export  */

var ISSUABLE_INDEX = {
  MERGE_REQUEST: 'merge_request_',
  ISSUE: 'issue_'
};

/***/ }),

/***/ "./pages/projects/issues/index/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issuable_index__ = __webpack_require__("./issuable_index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_search_init_filtered_search__ = __webpack_require__("./pages/search/init_filtered_search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_constants__ = __webpack_require__("./pages/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_projects_constants__ = __webpack_require__("./pages/projects/constants.js");
/* eslint-disable no-new */








document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_3__pages_search_init_filtered_search__["a" /* default */])({
    page: __WEBPACK_IMPORTED_MODULE_4__pages_constants__["a" /* FILTERED_SEARCH */].ISSUES
  });
  new __WEBPACK_IMPORTED_MODULE_0__issuable_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5__pages_projects_constants__["a" /* ISSUABLE_INDEX */].ISSUE);

  new __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */]();
});

/***/ }),

/***/ "./pages/search/init_filtered_search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__ = __webpack_require__("./filtered_search/filtered_search_manager.js");


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var page = _ref.page,
      filteredSearchTokenKeys = _ref.filteredSearchTokenKeys,
      isGroup = _ref.isGroup,
      isGroupAncestor = _ref.isGroupAncestor,
      isGroupDecendent = _ref.isGroupDecendent,
      stateFiltersSelector = _ref.stateFiltersSelector;

  var filteredSearchEnabled = __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__["a" /* default */] && document.querySelector('.filtered-search');
  if (filteredSearchEnabled) {
    var filteredSearchManager = new __WEBPACK_IMPORTED_MODULE_0__filtered_search_filtered_search_manager__["a" /* default */]({
      page: page,
      isGroup: isGroup,
      isGroupAncestor: isGroupAncestor,
      isGroupDecendent: isGroupDecendent,
      filteredSearchTokenKeys: filteredSearchTokenKeys,
      stateFiltersSelector: stateFiltersSelector
    });
    filteredSearchManager.setup();
  }
});

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ }),

/***/ "./subscription_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = subscriptionSelect;
function subscriptionSelect() {
  $('.js-subscription-event').each(function (i, element) {
    var fieldName = $(element).data('fieldName');

    return $(element).glDropdown({
      selectable: true,
      fieldName: fieldName,
      toggleLabel: function toggleLabel(selected, el, instance) {
        var label = 'Subscription';
        var $item = instance.dropdown.find('.is-active');
        if ($item.length) {
          label = $item.text();
        }
        return label;
      },
      clicked: function clicked(options) {
        return options.e.preventDefault();
      },
      id: function id(obj, el) {
        return $(el).data('id');
      }
    });
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global emitSidebarEvent */



// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = window.emitSidebarEvent || $.noop;

function UsersSelect(currentUser, els) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var $els;
  this.users = this.users.bind(this);
  this.user = this.user.bind(this);
  this.usersPath = "/autocomplete/users.json";
  this.userPath = "/autocomplete/users/:id.json";
  if (currentUser != null) {
    if ((typeof currentUser === 'undefined' ? 'undefined' : _typeof(currentUser)) === 'object') {
      this.currentUser = currentUser;
    } else {
      this.currentUser = JSON.parse(currentUser);
    }
  }

  var handleClick = options.handleClick;


  $els = $(els);

  if (!els) {
    $els = $('.js-user-search');
  }

  $els.each(function (_this) {
    return function (i, dropdown) {
      var options = {};
      var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, defaultNullUser, firstUser, issueURL, selectedId, selectedIdDefault, showAnyUser, showNullUser, showMenuAbove;
      $dropdown = $(dropdown);
      options.projectId = $dropdown.data('projectId');
      options.groupId = $dropdown.data('groupId');
      options.showCurrentUser = $dropdown.data('currentUser');
      options.todoFilter = $dropdown.data('todoFilter');
      options.todoStateFilter = $dropdown.data('todoStateFilter');
      showNullUser = $dropdown.data('nullUser');
      defaultNullUser = $dropdown.data('nullUserDefault');
      showMenuAbove = $dropdown.data('showMenuAbove');
      showAnyUser = $dropdown.data('anyUser');
      firstUser = $dropdown.data('firstUser');
      options.authorId = $dropdown.data('authorId');
      defaultLabel = $dropdown.data('defaultLabel');
      issueURL = $dropdown.data('issueUpdate');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      abilityName = $dropdown.data('abilityName');
      $value = $block.find('.value');
      $collapsedSidebar = $block.find('.sidebar-collapsed-user');
      $loading = $block.find('.block-loading').fadeOut();
      selectedIdDefault = defaultNullUser && showNullUser ? 0 : null;
      selectedId = $dropdown.data('selected');

      if (selectedId === undefined) {
        selectedId = selectedIdDefault;
      }

      var assignYourself = function assignYourself() {
        var unassignedSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=0]');

        if (unassignedSelected) {
          unassignedSelected.remove();
        }

        // Save current selected user to the DOM
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = $dropdown.data('fieldName');

        var currentUserInfo = $dropdown.data('currentUserInfo');

        if (currentUserInfo) {
          input.value = currentUserInfo.id;
          input.dataset.meta = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(currentUserInfo.name);
        } else if (_this.currentUser) {
          input.value = _this.currentUser.id;
        }

        if ($selectbox) {
          $dropdown.parent().before(input);
        } else {
          $dropdown.after(input);
        }
      };

      if ($block[0]) {
        $block[0].addEventListener('assignYourself', assignYourself);
      }

      var getSelectedUserInputs = function getSelectedUserInputs() {
        return $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]');
      };

      var getSelected = function getSelected() {
        return getSelectedUserInputs().map(function (index, input) {
          return parseInt(input.value, 10);
        }).get();
      };

      var checkMaxSelect = function checkMaxSelect() {
        var maxSelect = $dropdown.data('maxSelect');
        if (maxSelect) {
          var selected = getSelected();

          if (selected.length > maxSelect) {
            var firstSelectedId = selected[0];
            var firstSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=' + firstSelectedId + ']');

            firstSelected.remove();
            emitSidebarEvent('sidebar.removeAssignee', {
              id: firstSelectedId
            });
          }
        }
      };

      var getMultiSelectDropdownTitle = function getMultiSelectDropdownTitle(selectedUser, isSelected) {
        var selectedUsers = getSelected().filter(function (u) {
          return u !== 0;
        });

        var firstUser = getSelectedUserInputs().map(function (index, input) {
          return {
            name: input.dataset.meta,
            value: parseInt(input.value, 10)
          };
        }).filter(function (u) {
          return u.id !== 0;
        }).get(0);

        if (selectedUsers.length === 0) {
          return '未指派';
        } else if (selectedUsers.length === 1) {
          return firstUser.name;
        } else if (isSelected) {
          var otherSelected = selectedUsers.filter(function (s) {
            return s !== selectedUser.id;
          });
          return selectedUser.name + ' + ' + otherSelected.length + ' more';
        } else {
          return firstUser.name + ' + ' + (selectedUsers.length - 1) + ' more';
        }
      };

      $('.assign-to-me-link').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).hide();

        if ($dropdown.data('multiSelect')) {
          assignYourself();
          checkMaxSelect();

          var currentUserInfo = $dropdown.data('currentUserInfo');
          $dropdown.find('.dropdown-toggle-text').text(getMultiSelectDropdownTitle(currentUserInfo)).removeClass('is-default');
        } else {
          var $input = $('input[name="' + $dropdown.data('fieldName') + '"]');
          $input.val(gon.current_user_id);
          selectedId = $input.val();
          $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
        }
      });

      $block.on('click', '.js-assign-yourself', function (e) {
        e.preventDefault();
        return assignTo(_this.currentUser.id);
      });

      assignTo = function assignTo(selected) {
        var data;
        data = {};
        data[abilityName] = {};
        data[abilityName].assignee_id = selected != null ? selected : null;
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');

        return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(issueURL, data).then(function (_ref) {
          var data = _ref.data;

          var user;
          $dropdown.trigger('loaded.gl.dropdown');
          $loading.fadeOut();
          if (data.assignee) {
            user = {
              name: data.assignee.name,
              username: data.assignee.username,
              avatar: data.assignee.avatar_url
            };
          } else {
            user = {
              name: '未指派',
              username: '',
              avatar: ''
            };
          }
          $value.html(assigneeTemplate(user));
          $collapsedSidebar.attr('title', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name)).tooltip('fixTitle');
          return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
        });
      };
      collapsedAssigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
      assigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
      return $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          return _this.users(term, options, function (users) {
            // GitLabDropdownFilter returns this.instance
            // GitLabDropdownRemote returns this.options.instance
            var glDropdown = this.instance || this.options.instance;
            glDropdown.options.processData(term, users, callback);
          }.bind(this));
        },
        processData: function processData(term, data, callback) {
          var users = data;

          // Only show assigned user list when there is no search term
          if ($dropdown.hasClass('js-multiselect') && term.length === 0) {
            var selectedInputs = getSelectedUserInputs();

            // Potential duplicate entries when dealing with issue board
            // because issue board is also managed by vue
            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(selectedInputs, false, function (a) {
              return a.value;
            }).filter(function (input) {
              var userId = parseInt(input.value, 10);
              var inUsersArray = users.find(function (u) {
                return u.id === userId;
              });

              return !inUsersArray && userId !== 0;
            }).map(function (input) {
              var userId = parseInt(input.value, 10);
              var _input$dataset = input.dataset,
                  avatarUrl = _input$dataset.avatarUrl,
                  avatar_url = _input$dataset.avatar_url,
                  name = _input$dataset.name,
                  username = _input$dataset.username;

              return {
                avatar_url: avatarUrl || avatar_url,
                id: userId,
                name: name,
                username: username
              };
            });

            users = data.concat(selectedUsers);
          }

          var anyUser = void 0;
          var index = void 0;
          var j = void 0;
          var len = void 0;
          var name = void 0;
          var obj = void 0;
          var showDivider = void 0;
          if (term.length === 0) {
            showDivider = 0;
            if (firstUser) {
              // Move current user to the front of the list
              for (index = j = 0, len = users.length; j < len; index = j += 1) {
                obj = users[index];
                if (obj.username === firstUser) {
                  users.splice(index, 1);
                  users.unshift(obj);
                  break;
                }
              }
            }
            if (showNullUser) {
              showDivider += 1;
              users.unshift({
                beforeDivider: true,
                name: '未指派',
                id: 0
              });
            }
            if (showAnyUser) {
              showDivider += 1;
              name = showAnyUser;
              if (name === true) {
                name = 'Any User';
              }
              anyUser = {
                beforeDivider: true,
                name: name,
                id: null
              };
              users.unshift(anyUser);
            }

            if (showDivider) {
              users.splice(showDivider, 0, 'divider');
            }

            if ($dropdown.hasClass('js-multiselect')) {
              var selected = getSelected().filter(function (i) {
                return i !== 0;
              });

              if (selected.length > 0) {
                if ($dropdown.data('dropdownHeader')) {
                  showDivider += 1;
                  users.splice(showDivider, 0, {
                    header: $dropdown.data('dropdownHeader')
                  });
                }

                var _selectedUsers = users.filter(function (u) {
                  return selected.indexOf(u.id) !== -1;
                }).sort(function (a, b) {
                  return a.name > b.name;
                });

                users = users.filter(function (u) {
                  return selected.indexOf(u.id) === -1;
                });

                _selectedUsers.forEach(function (selectedUser) {
                  showDivider += 1;
                  users.splice(showDivider, 0, selectedUser);
                });

                users.splice(showDivider + 1, 0, 'divider');
              }
            }
          }

          callback(users);
          if (showMenuAbove) {
            $dropdown.data('glDropdown').positionMenuAbove();
          }
        },
        filterable: true,
        filterRemote: true,
        search: {
          fields: ['name', 'username']
        },
        selectable: true,
        fieldName: $dropdown.data('fieldName'),
        toggleLabel: function toggleLabel(selected, el, glDropdown) {
          var inputValue = glDropdown.filterInput.val();

          if (this.multiSelect && inputValue === '') {
            // Remove non-users from the fullData array
            var users = glDropdown.filteredFullData();
            var callback = glDropdown.parseData.bind(glDropdown);

            // Update the data model
            this.processData(inputValue, users, callback);
          }

          if (this.multiSelect) {
            return getMultiSelectDropdownTitle(selected, $(el).hasClass('is-active'));
          }

          if (selected && 'id' in selected && $(el).hasClass('is-active')) {
            $dropdown.find('.dropdown-toggle-text').removeClass('is-default');
            if (selected.text) {
              return selected.text;
            } else {
              return selected.name;
            }
          } else {
            $dropdown.find('.dropdown-toggle-text').addClass('is-default');
            return defaultLabel;
          }
        },
        defaultLabel: defaultLabel,
        hidden: function hidden(e) {
          if ($dropdown.hasClass('js-multiselect')) {
            emitSidebarEvent('sidebar.saveAssignees');
          }

          if (!$dropdown.data('alwaysShowSelectbox')) {
            $selectbox.hide();

            // Recalculate where .value is because vue might have changed it
            $block = $selectbox.closest('.block');
            $value = $block.find('.value');
            // display:block overrides the hide-collapse rule
            $value.css('display', '');
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        inputMeta: $dropdown.data('inputMeta'),
        clicked: function clicked(options) {
          var $el = options.$el,
              e = options.e,
              isMarking = options.isMarking;

          var user = options.selectedObj;

          if ($dropdown.hasClass('js-multiselect')) {
            var isActive = $el.hasClass('is-active');
            var previouslySelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value!=0]");

            // Enables support for limiting the number of users selected
            // Automatically removes the first on the list if more users are selected
            checkMaxSelect();

            if (user.beforeDivider && user.name.toLowerCase() === '未指派') {
              // Unassigned selected
              previouslySelected.each(function (index, element) {
                var id = parseInt(element.value, 10);
                element.remove();
              });
              emitSidebarEvent('sidebar.removeAllAssignees');
            } else if (isActive) {
              // user selected
              emitSidebarEvent('sidebar.addAssignee', user);

              // Remove unassigned selection (if it was previously selected)
              var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value=0]");

              if (unassignedSelected) {
                unassignedSelected.remove();
              }
            } else {
              if (previouslySelected.length === 0) {
                // Select unassigned because there is no more selected users
                this.addInput($dropdown.data('fieldName'), 0, {});
              }

              // User unselected
              emitSidebarEvent('sidebar.removeAssignee', user);
            }

            if (getSelected().find(function (u) {
              return u === gon.current_user_id;
            })) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
          }

          var isIssueIndex, isMRIndex, page, selected;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === page && page === 'projects:merge_requests:index';
          if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
            e.preventDefault();

            var isSelecting = user.id !== selectedId;
            selectedId = isSelecting ? user.id : selectedIdDefault;

            if (selectedId === gon.current_user_id) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
            return;
          }
          if ($el.closest('.add-issues-modal').length) {
            gl.issueBoards.ModalStore.store.filter[$dropdown.data('fieldName')] = user.id;
          } else if (handleClick) {
            e.preventDefault();
            handleClick(user, isMarking);
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            return Issuable.filterResults($dropdown.closest('form'));
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if (!$dropdown.hasClass('js-multiselect')) {
            selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "']").val();
            return assignTo(selected);
          }

          // Automatically close dropdown after assignee is selected
          // since CE has no multiple assignees
          // EE does not have a max-select
          if ($dropdown.data('maxSelect') && getSelected().length === $dropdown.data('maxSelect')) {
            // Close the dropdown
            $dropdown.dropdown('toggle');
          }
        },
        id: function id(user) {
          return user.id;
        },
        opened: function opened(e) {
          var $el = $(e.currentTarget);
          var selected = getSelected();
          if ($dropdown.hasClass('js-issue-board-sidebar') && selected.length === 0) {
            this.addInput($dropdown.data('fieldName'), 0, {});
          }
          $el.find('.is-active').removeClass('is-active');

          function highlightSelected(id) {
            $el.find('li[data-user-id="' + id + '"] .dropdown-menu-user-link').addClass('is-active');
          }

          if (selected.length > 0) {
            getSelected().forEach(function (selectedId) {
              return highlightSelected(selectedId);
            });
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            highlightSelected(0);
          } else {
            highlightSelected(selectedId);
          }
        },
        updateLabel: $dropdown.data('dropdownTitle'),
        renderRow: function renderRow(user) {
          var avatar, img, listClosingTags, listWithName, listWithUserName, username;
          username = user.username ? "@" + user.username : "";
          avatar = user.avatar_url ? user.avatar_url : gon.default_avatar_url;

          var selected = false;

          if (this.multiSelect) {
            selected = getSelected().find(function (u) {
              return user.id === u;
            });

            var fieldName = this.fieldName;
            var field = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "'][value='" + user.id + "']");

            if (field.length) {
              selected = true;
            }
          } else {
            selected = user.id === selectedId;
          }

          img = "";
          if (user.beforeDivider != null) {
            '<li><a href=\'#\' class=\'' + (selected === true ? 'is-active' : '') + '\'>' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '</a></li>';
          } else {
            img = "<img src='" + avatar + "' class='avatar avatar-inline' width='32' />";
          }

          return '\n            <li data-user-id=' + user.id + '>\n              <a href=\'#\' class=\'dropdown-menu-user-link ' + (selected === true ? 'is-active' : '') + '\'>\n                ' + img + '\n                <strong class=\'dropdown-menu-user-full-name\'>\n                  ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '\n                </strong>\n                ' + (username ? '<span class=\'dropdown-menu-user-username\'>' + username + '</span>' : '') + '\n              </a>\n            </li>\n          ';
        }
      });
    };
  }(this));
  $('.ajax-users-select').each(function (_this) {
    return function (i, select) {
      var firstUser, showAnyUser, showEmailUser, showNullUser;
      var options = {};
      options.skipLdap = $(select).hasClass('skip_ldap');
      options.projectId = $(select).data('projectId');
      options.groupId = $(select).data('groupId');
      options.showCurrentUser = $(select).data('currentUser');
      options.authorId = $(select).data('authorId');
      options.skipUsers = $(select).data('skipUsers');
      showNullUser = $(select).data('nullUser');
      showAnyUser = $(select).data('anyUser');
      showEmailUser = $(select).data('emailUser');
      firstUser = $(select).data('firstUser');
      return $(select).select2({
        placeholder: "Search for a user",
        multiple: $(select).hasClass('multiselect'),
        minimumInputLength: 0,
        query: function query(_query) {
          return _this.users(_query.term, options, function (users) {
            var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
            data = {
              results: users
            };
            if (_query.term.length === 0) {
              if (firstUser) {
                // Move current user to the front of the list
                ref = data.results;
                for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                  obj = ref[index];
                  if (obj.username === firstUser) {
                    data.results.splice(index, 1);
                    data.results.unshift(obj);
                    break;
                  }
                }
              }
              if (showNullUser) {
                nullUser = {
                  name: '未指派',
                  id: 0
                };
                data.results.unshift(nullUser);
              }
              if (showAnyUser) {
                name = showAnyUser;
                if (name === true) {
                  name = 'Any User';
                }
                anyUser = {
                  name: name,
                  id: null
                };
                data.results.unshift(anyUser);
              }
            }
            if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
              var trimmed = _query.term.trim();
              emailUser = {
                name: "邀请 \"" + _query.term + "\" by email",
                username: trimmed,
                id: trimmed,
                invite: true
              };
              data.results.unshift(emailUser);
            }
            return _query.callback(data);
          });
        },
        initSelection: function initSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.initSelection.apply(_this, args);
        },
        formatResult: function formatResult() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatResult.apply(_this, args);
        },
        formatSelection: function formatSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatSelection.apply(_this, args);
        },
        dropdownCssClass: "ajax-users-dropdown",
        // we do not want to escape markup since we are displaying html in results
        escapeMarkup: function escapeMarkup(m) {
          return m;
        }
      });
    };
  }(this));
}

UsersSelect.prototype.initSelection = function (element, callback) {
  var id, nullUser;
  id = $(element).val();
  if (id === "0") {
    nullUser = {
      name: '未指派'
    };
    return callback(nullUser);
  } else if (id !== "") {
    return this.user(id, callback);
  }
};

UsersSelect.prototype.formatResult = function (user) {
  var avatar;
  if (user.avatar_url) {
    avatar = user.avatar_url;
  } else {
    avatar = gon.default_avatar_url;
  }
  return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar avatar-inline s32' src='" + avatar + "'></div> <div class='user-name dropdown-menu-user-full-name'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</div> <div class='user-username dropdown-menu-user-username'>" + (!user.invite ? "@" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.username) : "") + "</div> </div>";
};

UsersSelect.prototype.formatSelection = function (user) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name);
};

UsersSelect.prototype.user = function (user_id, callback) {
  if (!/^\d+$/.test(user_id)) {
    return false;
  }

  var url;
  url = this.buildUrl(this.userPath);
  url = url.replace(':id', user_id);
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref2) {
    var data = _ref2.data;

    callback(data);
  });
};

// Return users list. Filtered by query
// Only active users retrieved
UsersSelect.prototype.users = function (query, options, callback) {
  var url = this.buildUrl(this.usersPath);
  var params = {
    search: query,
    active: true,
    project_id: options.projectId || null,
    group_id: options.groupId || null,
    skip_ldap: options.skipLdap || null,
    todo_filter: options.todoFilter || null,
    todo_state_filter: options.todoStateFilter || null,
    current_user: options.showCurrentUser || null,
    author_id: options.authorId || null,
    skip_users: options.skipUsers || null
  };
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url, { params: params }).then(function (_ref3) {
    var data = _ref3.data;

    callback(data);
  });
};

UsersSelect.prototype.buildUrl = function (url) {
  if (gon.relative_url_root != null) {
    url = gon.relative_url_root.replace(/\/$/, '') + url;
  }
  return url;
};

/* harmony default export */ __webpack_exports__["a"] = (UsersSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/issues/index/index.js"]);


// WEBPACK FOOTER //
// pages.projects.issues.index.c8e5d8fb0317e6d9a27b.bundle.js